/* WU: Trasandina up to and including 28 px is shown in weight 700, not 900.
   Sizes are often fluid (clamp), so the real computed size is checked on load,
   on window resize and on newly inserted elements (filters, cart, previews). */
(function () {
  var MAX = 28, CLS = 'wu-tw';
  function tras(cs) { return cs.fontFamily.split(',')[0].toLowerCase().indexOf('trasandina') > -1; }
  function check(el) {
    if (el.nodeType !== 1 || !el.firstChild) return;
    var cs = getComputedStyle(el);
    if (!tras(cs)) { if (el.classList.contains(CLS)) el.classList.remove(CLS); return; }
    var small = parseFloat(cs.fontSize) <= MAX;
    if (small !== el.classList.contains(CLS)) el.classList.toggle(CLS, small);
  }
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    check(root);
    var all = root.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) check(all[i]);
  }
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 60); };
  function full() { scan(document.body); }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(full, 200); }, { passive: true });
  var queue = [], pending = false;
  new MutationObserver(function (list) {
    list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) queue.push(n); }); });
    if (!pending && queue.length) { pending = true; idle(function () { var q = queue; queue = []; pending = false; q.forEach(scan); }); }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(full);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', full); else full();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
